import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { auth0Interceptor } from '../../../../sdk/src/lib/interceptors/auth0.interceptor';
import { appRoutes } from './app.routes';
import { provideUserIdleConfig } from 'angular-user-idle';
import { environment } from '../environments/environment';
import { ENVIRONMENT_TOKEN } from '../../../values/environment.token';
import {
  DialogContainerService,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { NgxsModule } from '@ngxs/store';
import { TherapistListState } from './states/therapist-list.state';
import { AssessmentListState } from './states/assessment-list.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAuth0 } from '@auth0/auth0-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([auth0Interceptor])),
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        redirect_uri: environment.auth0RedirectUri,
        audience: environment.auth0Audience,
        scope: environment.auth0Scope,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: [`${environment.apiUrl}/*`],
      },
    }),
    provideUserIdleConfig({ idle: 600, timeout: 120, ping: 30 }),
    {
      provide: ENVIRONMENT_TOKEN,
      useValue: environment,
    },
    DialogService,
    DialogContainerService,
    importProvidersFrom(
      NgxsModule.forRoot([TherapistListState, AssessmentListState]),
      NgxsReduxDevtoolsPluginModule.forRoot()
    ),
  ],
};
